export default __webpack_public_path__ + "static/media/powerladder_policy.ab2d9ea3.png";